<template>
  <div class="playerInfoList">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header v-if="pageHeader === 0" @back="goBack"></el-page-header>
      <el-page-header v-if="pageHeader === 1" @back="goBack" :content="$t('lang.title_playerInfoList1')"></el-page-header>
      <el-page-header v-if="pageHeader === 2" @back="goBack" :content="$t('lang.title_playerInfoList2')"></el-page-header>
    </div>
    <!-- 信息显示 -->
    <div class="filters">
      <el-form ref="form" :model="form" label-width="120px" label-suffix=":" :inline="true">
        <!-- 姓名 -->
        <el-form-item :label="$t('lang.lab_name')">
          <span class="color-opacity80">{{ this.form.name|valueIsNull }}</span>
        </el-form-item>
        <!-- 年龄 -->
        <el-form-item :label="$t('lang.lab_age')">
          <span class="color-opacity80">{{ this.form.age|valueIsNull }}</span>
        </el-form-item>
        <!-- 性别 -->
        <el-form-item :label="$t('lang.lab_gender')">
          <span class="color-opacity80">{{ this.form.gender|valueIsNull }}</span>
        </el-form-item>
        <!-- 手机号 -->
        <el-form-item :label="$t('lang.lab_phone')">
          <span class="color-opacity80">{{ this.form.phone|valueIsNull }}</span>
        </el-form-item>
        <!-- 代表队 -->
        <el-form-item :label="$t('lang.lab_delegation')">
          <span class="color-opacity80">{{ this.form.teamName |valueIsNull }}</span>
        </el-form-item>
        <!-- 证件类型 -->
        <el-form-item :label="$t('lang.lab_certificateType')">
          <!-- 0: 身份证 -->
          <span class="color-opacity80" v-if="this.form.idType === '0'">{{$t('lang.MeetingRecordDetail_idType[0].name')}}</span>
          <!-- 1: 护照 -->
          <span class="color-opacity80" v-if="this.form.idType === '1'">{{$t('lang.MeetingRecordDetail_idType[1].name')}}</span>
          <!-- 2: 港澳身份证 -->
          <span class="color-opacity80" v-if="this.form.idType === '2'">{{$t('lang.MeetingRecordDetail_idType[2].name')}}</span>
          <!-- 3: 台胞证 -->
          <span class="color-opacity80" v-if="this.form.idType === '3'">{{$t('lang.MeetingRecordDetail_idType[3].name')}}</span>
        </el-form-item>
        <!-- 证件号 -->
        <el-form-item :label="$t('lang.lab_certificateNum')">
          <span class="color-opacity80">{{this.form.idCard |valueIsNull}}</span>
        </el-form-item>
        <!-- 报名微信号 -->
        <el-form-item :label="$t('lang.lab_weChat')">
          <span class="color-opacity80">{{this.form.weChatAccount |valueIsNull}}</span>
        </el-form-item>
      </el-form>   
    </div>
    <!-- 表格 -->
    <el-card>   
      <!-- 数据导出 -->
      <el-button type="primary" slot="header" @click="onExport">{{$t('lang.btn_exportData')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @sort-change="changeTableSort"
      >
        <!-- 赛事名称 -->
        <el-table-column prop="competeName" :label="$t('lang.lab_competeName')" :sortable="'custom'"></el-table-column>
        <!-- 赛事项目 -->
        <el-table-column prop="competeItemName" :label="$t('lang.lab_competeItem')" :sortable="'custom'"></el-table-column>
        <!-- 组/道 -->
        <el-table-column prop="groupSwimLane" :label="$t('lang.lab_group_lane')" :sortable="'custom'"></el-table-column>
        <!-- 分组名次 -->
        <el-table-column prop="groupRanking" :label="$t('lang.lab_groupRanking')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.groupRanking | valueIsNull}}</span>
          </template>          
        </el-table-column>
        <!-- 总名次 -->
        <el-table-column prop="totalRanking" :label="$t('lang.lab_totalRanking')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.totalRanking | valueIsNull}}</span>
          </template>          
        </el-table-column>
        <!-- 成绩 -->
        <el-table-column prop="result" :label="$t('lang.lab_result')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.result | valueIsNull}}</span>
          </template>    
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:playerInfoList
 *@Description:选手信息及成绩
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-14
 */
import { excelDownload } from '../../config/download.js'

export default {
  name: '',
  components: {},
  data() {
    return {
      pageHeader: 0,
      idCard: '', // 通过idCard查找选手信息及成绩
      form: {
        name: '',
        age: '',
        gender: '',
        phone: '',
        teamName: '',
        weChatAccount: '',
        idCard: '',
        idType: '',
      }, // 选手信息数据
      /* 选手成绩列表变量 */
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 选手成绩列表数据
      /* 数据导出 */
      allData: [], 
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 获取选手成绩列表数据
    getData() {
      this.$get(`/player/detail?idCard=${this.idCard}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取选手信息
    getInfoData() { 
      this.$get(`/player/offLine/playerBase?idCard=${this.idCard}`).then(
        res => {
          if (res && res.code === 200) {
            this.form = res.data
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag) { 
      if (flag) {
        this.pageNum = 1
      }
      this.$get(`/player/detail?idCard=${this.idCard}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true)
    },
    // 获取全部数据
    getAllData() {
      this.$get(`/player/detail?idCard=${this.idCard}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}`).then(
        res => {
          if (res && res.code === 200) {
            // 选手成绩列表
            this.allData = res.data.list
            // Excel表头
            const tHeader = [
              this.$i18n.t('lang.lab_competeName'),
              this.$i18n.t('lang.lab_competeItem'),
              this.$i18n.t('lang.lab_group_lane'),
              this.$i18n.t('lang.lab_groupRanking'),
              this.$i18n.t('lang.lab_totalRanking'),
              this.$i18n.t('lang.lab_result'),
            ]
            // 对应table数据的列字段名
            const filterVal = [
              'competeName',
              'competeItemName',
              'groupSwimLane',
              'groupRanking',
              'totalRanking',
              'exportResult',
            ]
            excelDownload(tHeader, filterVal, this.allData, this.form.name + this.$i18n.t('lang.lab_playerInfoList'))
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 数据导出
    onExport() {
      if (navigator.onLine) {
        this.getAllData()
      } else {
        this.$message.error(this.$i18n.t('lang.warning_network'))
      }      
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    this.idCard = this.$route.query.idCard
    this.pageHeader = this.$route.query.source
    if (this.idCard !== '') {
      this.getInfoData()
      this.getData()
    }
  },
  mounted() {}
}
</script>

<style lang='scss'>
.playerInfoList{
 .color-opacity80{
   color: #636363;
 }
}
</style>
